import i18n from 'i18n';
import { addError } from 'redux-flash-messages';

import { api } from 'helpers/api';

import { MetaData, PrimerSession } from 'types/primer';
import { getNpsPaymentMethodId } from 'helpers/paymentHelper';

// eslint-disable-next-line import/prefer-default-export
export const createNpsSessionToken = async (
  userId: number,
  offerId: number,
  metaData: MetaData
): Promise<PrimerSession> => {
  try {
    const npsPaymodeId = getNpsPaymentMethodId();

    return await api(`pay/checkout/${offerId}/${userId}/${npsPaymodeId}`, {
      method: 'POST',
      body: metaData,
    });
  } catch (e) {
    addError({ text: i18n.t('error.500_error') });
    throw e;
  }
};
